import React from "react";
import { Link } from "react-router-dom";
import PolicyLayout from "./PolicyLayout";
import { POLICY_GROUPS } from "../config/policyConfig";

function PolicyIndex() {
  return (
    <PolicyLayout
      title="Policy guide"
      intro="Choose the policy that matches the stage of your purchase, the product involved, or the information you want to manage."
    >
      <div className="policy-directory" aria-label="Policy directory">
        {POLICY_GROUPS.map((group) => (
          <section className="policy-directory__group" key={group.title}>
            <h2>{group.title}</h2>
            <ul>
              {group.links.map(([label, path]) => (
                <li key={path}><Link to={path}>{label}<span aria-hidden="true">→</span></Link></li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </PolicyLayout>
  );
}

export default PolicyIndex;
